// extracted by mini-css-extract-plugin
export var borderRadius = "_dv-4";
export var large = "_dv-3";
export var logoContainer = "_dv-0";
export var nameLogo = "_dv-2";
export var small = "_dv-1";